import { render, staticRenderFns } from "./SurveyImageInput.vue?vue&type=template&id=c3883a56&scoped=true"
import script from "./SurveyImageInput.vue?vue&type=script&lang=js"
export * from "./SurveyImageInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3883a56",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3029718028/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3883a56')) {
      api.createRecord('c3883a56', component.options)
    } else {
      api.reload('c3883a56', component.options)
    }
    module.hot.accept("./SurveyImageInput.vue?vue&type=template&id=c3883a56&scoped=true", function () {
      api.rerender('c3883a56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/survey-builder/components/SurveyImageInput.vue"
export default component.exports